export function currencyFormat(value) {
  if (typeof value === 'number'){
    return value.toLocaleString('sk') + ' Kč'
  }
  return value
}
